// Configuração do Mercado Pago
// Use variáveis de ambiente em produção

export const MERCADO_PAGO_CONFIG = {
  // ⚠️ IMPORTANTE: Credenciais sensíveis ficam APENAS no servidor
  // Token e Webhook ficam em api/generate-pix.js (não expostos no navegador)
  
  // URL base da API (público - pode expor)
  API_URL: 'https://api.mercadopago.com/v1',
  
  // Configurações de pagamento (público - pode expor)
  PAYMENT_CONFIG: {
    description: 'Compra de Saldo - VitorTable MT'
  }
};

// Função para gerar QR Code PIX via Mercado Pago
export const generatePixQRCode = async (amount, description, options = {}) => {
  try {
    const { customerEmail, buyer } = options || {};

    const normalizedEmail = (customerEmail || buyer?.email || 'customer@vitortable.com').trim();

    const isLocal = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname === '';
    
    const isProduction = window.location.hostname.includes('vercel.app') || 
                        window.location.hostname.includes('vitormesas2025') ||
                        (!isLocal && window.location.hostname !== '');
    
    // SEMPRE usar serverless function (tanto em dev quanto em produção)
    // Em produção no Vercel, SEMPRE será real
    const apiUrl = window.location.origin + '/api/generate-pix';
    
    console.log('🔧 Gerando PIX via serverless function...', {
      apiUrl,
      hostname: window.location.hostname,
      isLocal,
      isProduction,
      amount,
      description,
      buyer: buyer?.name || null
    });
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        amount: parseFloat(amount),
        description: description,
        customerEmail: normalizedEmail,
        buyer
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Erro desconhecido' }));
      console.error('❌ Erro ao gerar PIX:', {
        status: response.status,
        statusText: response.statusText,
        error: errorData,
        isProduction
      });
      
      // Em produção, NUNCA usar mock - retornar erro
      if (isProduction) {
        throw new Error(errorData.message || `Erro ao gerar QR Code PIX (${response.status}). Verifique as credenciais do Mercado Pago no Vercel.`);
      }
      
      // Apenas em desenvolvimento local, usar mock como fallback
      if (isLocal) {
        console.warn('⚠️ Serverless function não disponível localmente, usando mock para desenvolvimento');
        const mockTransactionId = 'DEV-' + Date.now();
        const amountFormatted = amount.toFixed(2).replace('.', '');
        const amountPadded = amountFormatted.padStart(13, '0');
        const mockQrCode = `00020126${amountPadded.length.toString().padStart(2, '0')}${amountPadded}26580014br.gov.bcb.pix0136123456789012345678901234567890123456789012345678905204000053039865405${amountPadded}802BR5925VITOR TABLE MT6009SAO PAULO62140510${mockTransactionId}6304ABCD`;
        
        return {
          qrCode: mockQrCode,
          qrCodeBase64: null,
          qrCodeUrl: null,
          transactionId: mockTransactionId,
          status: 'pending',
          expirationDate: new Date(Date.now() + 15 * 60 * 1000).toISOString(),
          amount: parseFloat(amount),
          isMock: true
        };
      }
      
      throw new Error(errorData.message || `Erro ao gerar QR Code PIX (${response.status})`);
    }

    const data = await response.json();
    
    if (!data.success) {
      console.error('❌ Falha ao gerar PIX:', data);
      
      // Em produção, NUNCA usar mock
      if (isProduction) {
        throw new Error(data.error || 'Falha ao gerar PIX. Verifique as credenciais do Mercado Pago no Vercel.');
      }
      
      // Apenas em desenvolvimento local, usar mock
      if (isLocal) {
        console.warn('⚠️ Retornando mock devido à falha na API');
        const mockTransactionId = 'DEV-' + Date.now();
        const amountFormatted = amount.toFixed(2).replace('.', '');
        const amountPadded = amountFormatted.padStart(13, '0');
        const mockQrCode = `00020126${amountPadded.length.toString().padStart(2, '0')}${amountPadded}26580014br.gov.bcb.pix0136123456789012345678901234567890123456789012345678905204000053039865405${amountPadded}802BR5925VITOR TABLE MT6009SAO PAULO62140510${mockTransactionId}6304ABCD`;
        
        return {
          qrCode: mockQrCode,
          qrCodeBase64: null,
          qrCodeUrl: null,
          transactionId: mockTransactionId,
          status: 'pending',
          expirationDate: new Date(Date.now() + 15 * 60 * 1000).toISOString(),
          amount: parseFloat(amount),
          isMock: true
        };
      }
      
      throw new Error(data.error || 'Falha ao gerar PIX');
    }
    
    console.log('✅ PIX gerado com sucesso!', {
      transactionId: data.transactionId,
      hasQrCode: !!data.qrCode,
      hasQrCodeBase64: !!data.qrCodeBase64,
      hasQrCodeUrl: !!data.qrCodeUrl,
      status: data.status,
      isProduction,
      isReal: !data.qrCode?.includes('DEV-') && !data.qrCode?.includes('ERR-')
    });
    
    return {
      qrCode: data.qrCode,
      qrCodeBase64: data.qrCodeBase64,
      qrCodeUrl: data.qrCodeUrl,
      transactionId: data.transactionId,
      status: data.status,
      expirationDate: data.expirationDate,
      amount: data.amount,
      isMock: false
    };
  } catch (error) {
    console.error('❌ Erro ao gerar PIX:', error);
    console.error('Stack:', error.stack);
    
    const isLocal = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname === '';
    
    const isProduction = window.location.hostname.includes('vercel.app') || 
                        window.location.hostname.includes('vitormesas2025') ||
                        (!isLocal && window.location.hostname !== '');
    
    // Em produção, NUNCA retornar mock - sempre lançar erro
    if (isProduction) {
      console.error('❌ ERRO CRÍTICO: Não foi possível gerar PIX real em produção!');
      console.error('Verifique:', {
        message: '1. Se MERCADO_PAGO_ACCESS_TOKEN está configurado no Vercel',
        message2: '2. Se o token é válido',
        message3: '3. Se a serverless function está funcionando'
      });
      throw error;
    }
    
    // Apenas em desenvolvimento local, usar mock como último recurso
    if (isLocal) {
      console.warn('⚠️ Retornando mock devido ao erro (apenas desenvolvimento)');
      const mockTransactionId = 'ERR-' + Date.now();
      const amountFormatted = amount.toFixed(2).replace('.', '');
      const amountPadded = amountFormatted.padStart(13, '0');
      const mockQrCode = `00020126${amountPadded.length.toString().padStart(2, '0')}${amountPadded}26580014br.gov.bcb.pix0136123456789012345678901234567890123456789012345678905204000053039865405${amountPadded}802BR5925VITOR TABLE MT6009SAO PAULO62140510${mockTransactionId}6304ABCD`;
      
      return {
        qrCode: mockQrCode,
        qrCodeBase64: null,
        qrCodeUrl: null,
        transactionId: mockTransactionId,
        status: 'pending',
        expirationDate: new Date(Date.now() + 15 * 60 * 1000).toISOString(),
        amount: parseFloat(amount),
        isMock: true
      };
    }
    
    // Em produção, nunca retornar null silenciosamente - lançar erro
    throw error;
  }
};

// Função para verificar status do pagamento
export const checkPaymentStatus = async (transactionId) => {
  try {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    if (isLocal) {
      // Modo desenvolvimento: simular aprovação
      console.warn('🔧 Modo desenvolvimento: Simulando status aprovado');
      
      if (transactionId.startsWith('DEV-')) {
        return {
          status: 'approved',
          statusDetail: 'accredited',
          amount: 50.00,
          dateApproved: new Date().toISOString()
        };
      }
    }
    
    const apiUrl = window.location.origin + `/api/check-payment?transactionId=${transactionId}`;
    
    const response = await fetch(apiUrl, {
      method: 'GET'
    });

    if (!response.ok) {
      throw new Error('Erro ao verificar pagamento');
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error('Falha ao verificar pagamento');
    }
    
    return {
      status: data.status,
      statusDetail: data.statusDetail,
      amount: data.amount,
      dateApproved: data.dateApproved
    };
  } catch (error) {
    console.error('Erro ao verificar pagamento:', error);
    return null;
  }
};

// Função para cancelar pagamento
export const cancelPayment = async (transactionId) => {
  try {

    const response = await fetch(`${MERCADO_PAGO_CONFIG.API_URL}/payments/${transactionId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${MERCADO_PAGO_CONFIG.ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        status: 'cancelled'
      })
    });

    if (!response.ok) {
      throw new Error('Erro ao cancelar pagamento');
    }

    return { success: true };
  } catch (error) {
    console.error('Erro ao cancelar pagamento:', error);
    return { success: false, error: error.message };
  }
};
